PageApp.Ent.LayoutHacks = Backbone.Model.extend({
  getDimensionsHomeCal: function () {
    return { width: 320, height: 210 }
  }
})
